import { isAuthenticated } from '../guards/auth';

export default [
  {
    path: '/zpracovani-objednavky',
    name: 'processing',
    meta: { moduleId: 'processing' },
    component: () => import(/* webpackChunkName: "processing" */ '@/views/processing/Search.vue'),
    beforeEnter: isAuthenticated,
  },
  {
    path: '/zpracovani-objednavky/detail/:id',
    name: 'processing.detail',
    meta: { moduleId: 'processingDetail' },
    component: () => import(/* webpackChunkName: "processing" */ '@/views/processing/Detail.vue'),
    beforeEnter: isAuthenticated,
  },
];
